export enum TicketStatusEnum {
  PendingData = 0, // não nominal e ainda sem portador
  Ready = 1, // válido para uso
  Used = 2,
  Canceled = 3,
  Transferred = 4,
  Reserved = 5, // aguardando confirmação de pagamento (PIX/Boleto)
}

export enum QrCodeStatusEnum {
  Invalid = 0, // ex.: não nominal sem holder
  Ready = 1, // pronto para validação
  Used = 2,
  Revoked = 3,
}

// Estado da sincronização do ingresso como participante no Celetus Pass.
export enum PassSyncStatusEnum {
  NotSent = 0, // ainda não enviado (ou evento sem Pass habilitado)
  Sent = 1, // enviado, sem confirmação persistida (alvo de retry)
  Confirmed = 2, // Pass confirmou o participante
  Rejected = 3, // Pass rejeitou (ver passSyncError) - alvo de retry
}

export type TProductTicket = {
  id: string
  codeId: string
  orderCode: string
  offerName: string
  buyerName: string
  buyerEmail: string
  tierTitle?: string | null
  ticketSection?: string | null
  holderName?: string | null
  holderMail?: string | null
  holderPhone?: string | null
  holderDocument?: string | null
  status: TicketStatusEnum
  qrStatus: QrCodeStatusEnum
  passSyncStatus?: PassSyncStatusEnum
  passSyncError?: string | null
}

export type TProductTicketPagination = {
  items: TProductTicket[]
  page: number
  rowsPerPage: number
  totalPages: number
  total: number
}

export enum ProductTicketLotCriterion {
  quantity = 1,
  date = 2,
  both = 3,
}

export interface ProductTicketLotVM {
  id?: string
  areaId?: string
  name: string
  criterion: ProductTicketLotCriterion
  startDate?: string | Date | null
  endDate?: string | Date | null
  unitLimit?: number
  order: number
  offerId: string
  offerCodeId: string
  offerName: string
  offerValue: number
}

export interface ProductTicketAreaVM {
  id?: string
  codeId?: string
  name: string
  description?: string
  capacity: number
  displayOrder: number
}

export interface ProductTicketFormValues {
  areas: (ProductTicketAreaVM & { lots: ProductTicketLotVM[] })[]
}

export type TProductTicketLog = {
  id: string
  codeId: string
  name: string
  email: string
  createdDate: Date
  oldPrice: number
  newPrice: number
}

export type TProductTicketLogPagination = {
  items: TProductTicketLog[]
  page: number
  rowsPerPage: number
  totalPages: number
  total: number
}
